<form [formGroup] = "questionForm">
  <h1 mat-dialog-title *ngIf = "data.mode == 1"> New Question</h1>
  <h1 mat-dialog-title *ngIf = "data.mode == 2"> Edit Question</h1>

  <div mat-dialog-content>

    <mat-form-field style="width:90%; padding-top:20px;">
        <mat-label>Description:</mat-label>
        <input matInput formControlName = "descr">
    </mat-form-field>


        <mat-form-field style="margin-top:20px;">
          <mat-label>Input Type</mat-label>
          <mat-select #inputType
             formControlName = "inpt">
            <mat-option value=1>Small Text Box</mat-option>
            <mat-option value=5>Large Text Box</mat-option>
            <mat-option value=3>Number</mat-option>
            <mat-option value=2>Checkbox</mat-option>
            <mat-option value=4>Multiple Choice</mat-option>
          </mat-select>
        </mat-form-field>

        <div *ngIf="inputType.value == 4">
          <mat-form-field style="width:90%; padding-top:20px;">
            <mat-label>Option:</mat-label>
            <input matInput #optionValue>
            <button mat-button style="background-color: green; color: white;" (click)="addOption(optionValue.value)"> Add </button>
          </mat-form-field>
        </div>

        <div *ngIf="inputType.value == 4" style="display: flex;
        align-items: center;
        flex-flow: column nowrap;
        border: 1px solid;
        height: 237px;
        overflow-y: scroll; ">

        <div *ngIf="choices.length < 1">
          <p>Dropdown choices will be added here.</p>
        </div>

        <div *ngIf="choices.length > 0">
          <div *ngFor="let option of choices; let indexofItem = index" style="margin-bottom: 5px;
          border: 1px solid lightgrey;">
            <p style=" margin: auto;
            padding: 5px;">{{option}} <button (click)='removeOption(indexofItem)' style="background-color: red;
            color: white;
            border: 0;
            border-radius: 4px;">X</button></p>
          </div>
        </div>



        </div>







        <!--
      <mat-form-field>
          <mat-label>Customer:</mat-label>
          <input matInput formControlName = "customer" [matAutocomplete] = "custauto">
        </mat-form-field>
  -->

  </div>

  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">Cancel</button>
    <button mat-button  (click)="saveClick()" cdkFocusInitial>Save</button>
  </div>
</form>
